export const adaptTipoPlan = (tipoPlanData) => {
    return {
        id: tipoPlanData?.idTipoPlan,
        displayName: tipoPlanData?.descripcion,
        name: tipoPlanData?.descripcion
    }
}

export const adaptTipoPlanArray = (
    tipoPlanes
) => {
    return structuredClone(tipoPlanes?.allTipoPlan)
        ?.map(tipoPlan => adaptTipoPlan(tipoPlan));
}